export enum REQUESTS_PATH {
    GET_NOTIFICATIONS = '/Notifications/My',
    GET_UNREAD_COUNT = '/Notifications/UnreadCount',
    READ_ALL_NOTIFICATIONS = '/Notifications/ReadAll',
    READ_SINGLE_NOTIFICATION = '/Notifications/ReadSingle'
}
